<template>
  <App
    :show-top-bar="false"
    :show-header="false"
    :show-sidebar="false"
    :show-banner="false"
  >
    <main role="main">
      <div class="hero-middle">
        <div class="text-center">
          <a href="/">
            <logo
              :width="250"
              :height="100"
              :icon-and-text="true"
            />
          </a>
        </div>
        <br>
        <div class="row">
          <div
            class="col-lg-6 col-md-8 ml-auto mr-auto"
            style="max-width: 380px"
          >
            <AlertsFeed />

            <div class="form-wrapper signin">
              <h1 class="h4 mb-5 text-center">
                Sign in to your account
              </h1>

              <template v-if="!is_whitelabel_host">
                <div
                  id="google_login_container_id"
                  class="google_login_container"
                  data-cy="google-button-container"
                >
                  <div
                    v-if="1===2"
                    id="g_id_onload"
                    :data-client_id="googleClientID"
                    data-context="signin"
                    data-ux_mode="popup"
                    :data-login_uri="baseURL + '/google_signin'"
                    data-itp_support="true"
                  />

                  <div
                    v-if="1===2"
                    class="g_id_signin"
                    data-type="standard"
                    data-shape="rectangular"
                    data-theme="outline"
                    data-text="signin_with"
                    data-size="large"
                    data-width="306"
                    data-logo_alignment="left"
                    style="margin-bottom: 1rem;"
                  />
                </div>
                <div class="auth-form-divider">
                  <div class="auth-form-divider-content">
                    or
                  </div>
                </div>
              </template>
              <sign-in-form v-if="!two_fa_enabled" />
              <two-factor-form v-else />
            </div>
          </div>
        </div>
        <!-- Don't show the below if is on whitelabel host-->
        <template v-if="!is_whitelabel_host">
          <br>
          <div class="text-center">
            <template v-if="!two_fa_enabled">
              Don't have an account yet? <a
                href="/signup"
                data-cy="signup-link"
              >Sign up for a 7 days free trial</a>
            </template>
            <template v-else>
              Need help? Please reach out to us at <a href="mailto:help@advancedwebranking.com">help@advancedwebranking.com</a> for further assistance.
            </template>
          </div>
        </template>
      </div>
    </main>
  </App>
</template>

<script>
import { defineComponent } from 'vue';
import logo from '@/components/nav/logo.vue';
import SignInForm from '@/components/SignInForm.vue';
import TwoFactorForm from '@/components/TwoFactorForm.vue';
import { useAwr } from '@/awr/stores/awr';
import { addGoogleScript, googleInitConfig } from '@/modules/auth/auth-composable';
import AlertsFeed from '@/components/AlertsFeed.vue';
import { useAlertStore } from '@/awr/stores/alert';

export default defineComponent({
  name: 'SignIn',
  components: {
    AlertsFeed,
    SignInForm,
    TwoFactorForm,
    logo,
  },
  data() {
    const awr = useAwr();

    return {
      login_error: awr.$state.loginError,
      is_whitelabel_host: awr.$state.isWhitelabelHost,
      googleClientID: awr.$state.googleClientID,
      baseURL: awr.$state.baseURL,
      two_fa_enabled: awr.$state.twoFaEnabled,
      alert: useAlertStore(),
    };
  },
  computed: {
    hasLoginErrors() {
      return this.login_error && this.login_error.length > 0;
    },
  },
  mounted() {
    addGoogleScript();

    window.onGoogleLibraryLoad = () => {
      googleInitConfig(this.googleClientID, 'signin', this.handleCredentialResponse, 306);
    };
    if (this.hasLoginErrors) {
      this.alert.addWarning({
        title: 'Login error',
        messageAdvanced: this.login_error,
        dismissible: false,
        attrs: {
          'data-cy': 'login-error',
        },
      });
    }
  },
  methods: {
    handleCredentialResponse(response) {
      const redirectValue = awr.baseURL + 'google_signin';
      window.location = redirectValue + '?credential=' + response.credential;
    },
  },
});
</script>

<style lang="scss">
  @import "@scss/pages/forms.scss";
</style>

<style>
.signin.form-wrapper {
  padding: 1.5rem;
  border-radius: 0.3rem;
  border: 1px solid #ced4da;
}
.auth-form-divider {
  font-size: 1rem;
  height: 2rem;
  position: relative;
  text-align: center;
  z-index: 0;
  margin-bottom: 1rem;
}
.auth-form-divider .auth-form-divider-content {
  background-color: #fff;
  display: inline-block;
  padding: 0.1rem 0.5rem;
}
.auth-form-divider:after {
  background-color: #ced4da;
  content: "";
  height: 1px;
  left: 0;
  position: absolute;
  top: 50%;
  width: 100%;
  z-index: -1;
}
.google_login_container {
  height: 44px;
  width: auto;
}
</style>
